<ng-container *ngIf="pollsQuestions.length > 0; else noGame">
  <ng-container *ngFor="let question of pollsQuestions; let i = index">
    <ng-container *ngIf="!question.Completed">
      <div
        class="fgbcl-games-polls-question-card"
        [ngClass]="{ 'fgbcl-games-polls-question-card-padding-bottom': question?.Sponsor?.SponsorId }"
      >
        <fgbcl-games-question-item
          [question]="question"
          [groupType]="groupType"
          [currentQuestionIndex]="question.Id"
          (answerSelected)="onAnswerSelected(question.Id, $event)"
          [isExternal]="isExternal"
        ></fgbcl-games-question-item>
        <div class="fgbcl-games-polls-sponsor-section" *ngIf="question?.Sponsor?.SponsorId">
          <div class="fgbcl-games-polls-sponsor-text">{{ 'fgbcl.game.modal.sponsor.presented.by.text' | translate }}:</div>
          <img
            class="fgbcl-games-polls-sponsor-image"
            src="{{ question?.Sponsor?.SponsorImage | contentImage: '1' }}"
          />
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="question.Completed">
      <div
        [ngClass]="{ 'fgbcl-games-polls-question-card-padding-bottom': question?.Sponsor?.SponsorId }"
        class="fgbcl-games-polls-question-card"
      >
        <fgbcl-game-polls-result [pollsQuestions]="question" [disableAnimation]="question.Id === submittedPollId ? false : true">
          <ng-container *ngIf="submissionFormTemplate">
            <ng-container *ngTemplateOutlet="submissionFormTemplate"></ng-container>
          </ng-container>
        </fgbcl-game-polls-result>
      </div>
    </ng-container>
  </ng-container>
</ng-container>
<!--Placeholder Information-->
<ng-template #noGame>
  <div class="games-placeholder">
    <div class="no-items no-results-placeholder-div">
      <div class="svg svg-info vs-svg ms-auto me-auto" fgbAnimateSvg [inlineSVG]="'assets/images/games/Polls.svg'"></div>
      <div class="no-results-placeholder">{{ 'fgbcl.game.no.item.available.polls.text' | translate }}</div>
    </div>
  </div>
</ng-template>
